
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = new Model({
	name: "activelivechatgroup",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	recalculate: recalculate,
	reset: reset
});

function init(){
	this.push(null);
}

function uninit(){
	this._viewing = null;
	this._groups = null;
}

function listeners(){
	return {
		"livechatgroups:updated": Model.makeRecalculator("groups")
	};
}

function triggers(){
	return {
		view: view,
		reset: reset
	};
}

function recalculate(){
	var groups = this._groups;
	var current = this._viewing;

	if(!current) return;

	var newGroup = findGroup(current._id, groups);

	if(!newGroup){
		this.dispatch("close");
		return this.reset();
	}

	var newGroupData = xtend(current, newGroup);

	this._viewing = newGroupData;
	this.push(newGroupData);
}

function view(data){
	var group = data.group;
	var groups = this._groups;

	var groupData = findGroup(group, groups);
	if(!groupData) return;

	this._viewing = groupData;
	this.push(groupData);
	this.dispatch("viewing", groupData);

	this.emit("usermetrics:trigger:track", "view livechat group", {
		"livechat group": groupData.name,
	});
}

function reset(){
	this.emit("usermetrics:trigger:track", "close livechat group", {
		"livechat group": this._viewing.name,
	});
	this._viewing = null;
	this.push(null);
}

function findGroup(group, groups){
	return groups.reduce(function(acc, data){
		if(data._id === group) acc = data;
		return acc;
	}, undefined);
}
